export default __webpack_public_path__ + "static/media/not_found~QUTksVkD.0650c164.png";